import { useEffect, useState } from 'react'
import { Label } from 'types/label'
import { db } from 'firebase/index'

const useFetchLabels = (): Label[] => {
  const [labels, setLabels] = useState<Label[]>([])
  useEffect(() => {
    db.collection('labels')
      .where('status', '==', 'public')
      .get()
      .then((snapshots) => {
        setLabels([
          ...snapshots.docs.map((snapshot) => {
            const data = snapshot.data() as Label
            data.ref = snapshot.ref
            return data
          }),
        ])
      })
  }, [])
  return labels
}

export default useFetchLabels
